import api from './api';

export interface Organization {
  id: string;
  name: string;
  slug: string;
}

export interface OrganizationMembership {
  id: string;
  organizationId: string;
  organizationName: string;
  organizationSlug: string;
  role: string;
  subscriptionTier?: string;
}

export interface OrganizationSettings {
  timezone: string;
  locale: string;
  notificationPreferences: Record<string, any>;
  integrationSettings: Record<string, any>;
  featureFlags: Record<string, any>;
}

export const organizationService = {
  async getUserOrganizations(): Promise<OrganizationMembership[]> {
    const response = await api.get('/auth/organizations');
    return response.data.organizations;
  },

  async getOrganizationSettings(organizationId: string): Promise<OrganizationSettings> {
    const response = await api.get(`/organizations/${organizationId}/settings`);
    return response.data.data;
  },

  async switchOrganization(organizationId: string): Promise<{ 
    token: string;
    currentOrganization: {
      id: string;
      name: string;
      slug: string;
    };
    user?: {
      id: string;
      email: string;
      name?: string;
      role: string;
      parentId?: string;
      currentOrganizationId?: string;
      availableOrganizations?: Array<{
        id: string;
        organizationId: string;
        organizationName: string;
        organizationSlug: string;
        role: string;
      }>;
    };
  }> {
    const response = await api.post('/auth/switch-organization', { organizationId });
    return response.data;
  },

  async createOrganization(name: string): Promise<Organization> {
    const response = await api.post('/organizations', { name });
    return response.data;
  },

  async deleteOrganization(orgSlug: string): Promise<void> {
    await api.delete(`/organizations/${orgSlug}`);
  }
};
